import React from "react";
import { color } from "d3-color";

import LiquidFillGauge from "react-liquid-gauge";

function Liquidgauge({ value, radius = "150", unit = "%" }) {

  return (
    <LiquidFillGauge
      style={{ margin: "0 auto" }}
      width={radius * 2}
      height={radius * 2}
      value={value}
      percent={unit}
      textSize={1}
      textOffsetX={10}
      textOffsetY={30}
      riseAnimation
      waveAnimation
      waveFrequency={2}
      waveAmplitude={1}
      gradient
      outerRadius={0.94}
      circleStyle={{
        fill: '#1890ff',
      }}
      waveStyle={{
        fill: '#1890ff',
      }}
      textStyle={{
        fill: color("#fff").toString(),
        fontFamily: "Arial",
      }}
      waveTextStyle={{
        fill: color("#fff").toString(),
        fontFamily: "Arial",
      }}
    />
  );
}

export default Liquidgauge;